var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import omit from 'rc-util/lib/omit';
import * as React from 'react';
import { tupleNum } from '../_util/type';
import warning from '../_util/warning';
import Base from './Base';
const TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5, 6);
const SubTitle = (_a, ref) => {
    var { block = true, ellipsis, level = 1, className } = _a, restProps = __rest(_a, ["block", "ellipsis", "level", "className"]);
    const mergedEllipsis = React.useMemo(() => {
        if (ellipsis && typeof ellipsis === 'object') {
            return omit(ellipsis, ['expandable', 'rows']);
        }
        return ellipsis;
    }, [ellipsis]);
    warning(typeof ellipsis !== 'object' ||
        !ellipsis ||
        (!('expandable' in ellipsis) && !('rows' in ellipsis)), 'Typography.Text', '`ellipsis` do not support `expandable` or `rows` props.');
    return (React.createElement(Base, Object.assign({ ref: ref }, restProps, { className: `typography-subtitle-${level} ${className || ''}`, ellipsis: mergedEllipsis, component: block ? 'div' : 'span' })));
};
export default React.forwardRef(SubTitle);
